var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002444(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.598633,
    y: 0.635742,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9733 35.4569H17.3097V21.5256H12.6035L21.5462 9.66357L30.5081 21.6193H25.6834V35.4569H17.3097",
    fill: "url(#paint0_linear_1352_1063)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1063",
    x1: 21.5558,
    y1: 15.1447,
    x2: 21.5558,
    y2: 35.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC845A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9046,
    height: 25.7933,
    fill: "white",
    transform: "translate(12.6035 9.66357)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002444);
export default __webpack_public_path__ + "static/media/Group-1000002444.736d3b2bb678009f6396ede1921b6e1e.svg";
export { ForwardRef as ReactComponent };